import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';

import { orderUpdateGetLimitHandler, orderUpdateItemsHandler } from './order-edit-methods-handlers';
import { MethodPropertiesKey } from '../../shared/consts';

export enum OrderEditMethods {
  CartFromOrderAdd = 'cartFromOrderAdd',
  OrderUpdateGetLimit = 'OrderUpdateGetLimit',
  CartItemAdd = 'CartItemAdd',
  OrderUpdateItems = 'orderUpdateItems',
}
export const ORDER_EDIT_HANDLER_LIST: MethodHandler = {
  [OrderEditMethods.OrderUpdateGetLimit]: orderUpdateGetLimitHandler,
  [OrderEditMethods.OrderUpdateItems]: orderUpdateItemsHandler,
};

export const ORDER_EDIT_PROPERTIES_LIST: MethodProperties = new Map([
  [
    OrderEditMethods.OrderUpdateGetLimit,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    OrderEditMethods.OrderUpdateItems,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
]);
